/* eslint-disable eol-last */
// java 涂工接口
import request from '@/utils/home/physical'
// 运单管理
export function selectoutbillorder(query) {
  return request({
    url: '/api/out/mt/api/order/selectoutbillorder',
    method: 'get',
    params: query
  })
}
// 新建出库单
export function insertoutbillorder(data) {
  return request({
    url: '/api/out/mt/api/order/insertoutbillorder',
    method: 'post',
    data
  })
}
export function insertoutbillorderproduct(data) {
  return request({
    url: '/api/out/mt/api/order/insertoutbillorderproduct',
    method: 'post',
    data
  })
}
// 出库单下载接口
export function donloadoutbillorder(query) {
  return request({
    url: '/api/out/mt/api/order/donloadoutbillorder',
    method: 'get',
    params: query
  })
}
// 修改出库单
export function updateoutbillorder(data) {
  return request({
    url: '/api/out/mt/api/order/updateoutbillorder',
    method: 'post',
    data
  })
}
// 删除出库单
export function deleteoutbillorder(query) {
  return request({
    url: '/api/out/mt/api/order/deleteoutbillorder',
    method: 'get',
    params: query
  })
}
// 完成出库
export function updateoutstatus(query) {
  return request({
    url: '/api/out/mt/api/order/updateoutstatus',
    method: 'get',
    params: query
  })
}
// 退货查询
export function queryrejected(query) {
  return request({
    url: '/api/out/mt/api/rejectedlog/queryrejected',
    method: 'get',
    params: query
  })
}
// 换货查询
export function selectoutbillorderbarter(query) {
  return request({
    url: '/api/out/mt/api/order/selectoutbillorderbarter',
    method: 'get',
    params: query
  })
}
// 解除运单关联
export function queryremove(query) {
  return request({
    url: '/api/out/mt/api/rejectedlog/queryremove',
    method: 'get',
    params: query
  })
}
// 箱码查询
export function selectoutbillorderqrcode(query) {
  return request({
    url: '/api/out/mt/api/order/selectoutbillorderqrcode',
    method: 'get',
    params: query
  })
}
// 消费者扫码
export function qrcodecount(query) {
  return request({
    url: '/api/out/mt/api/qrcode/qrcodecount',
    method: 'get',
    params: query
  })
}
// 消费者查询真伪页
export function queryconsumer(query) {
  return request({
    url: '/api/out/mt/api/consume/queryconsumer',
    method: 'get',
    params: query
  })
}
// 稽查流水报表
export function selectins(query) {
  return request({
    url: '/api/out/mt/api/msc/selectins',
    method: 'get',
    params: query
  })
}
// 预警清单http://192.168.4.21:8108/api/out/mt/api/consume/queryconsumerwarning
export function queryconsumerwarning(query) {
  return request({
    url: '/api/out/mt/api/consume/queryconsumerwarning',
    method: 'get',
    params: query
  })
}
// 取证记录
export function selectcorrect(query) {
  return request({
    url: '/api/out/mt/api/msc/selectcorrect',
    method: 'get',
    params: query
  })
}
export function selectimage(query) { // 查图片
  return request({
    url: '/api/out/mt/api/msc/selectimage',
    method: 'get',
    params: query
  })
}
export function findconfig(query) { // 查询配置预警参数
  return request({
    url: '/api/out/mt/api/consume/findconfig',
    method: 'get',
    params: query
  })
}
export function updateconfig(query) { // 修改预警参数
  return request({
    url: '/api/out/mt/api/consume/updateconfig',
    method: 'get',
    params: query
  })
}
export function findallbyqrcode(query) { // 产品信息查询
  return request({
    url: '/api/out/mt/api/consume/findallbyqrcode',
    method: 'get',
    params: query
  })
}
export function findqrcodenotinworkorder(data) { // 交货单查询
  return request({
    url: '/api/out/mt/api/pda/findqrcodenotinworkorder',
    method: 'post',
    data
  })
}
export function listtoken(query) { // 交货单查询
  return request({
    url: '/api/wms/logic/list',
    method: 'get',
    params: query
  })
}